<template>
	<v-dialog
		v-model="dialog"
		max-width="700px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				class="ml-2"
				:text="text"
				:color="text ? 'white' : 'secondary'"
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-2">mdi-magnify</v-icon>
				検索
			</v-btn>
		</template>

		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">検索</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2">
				<v-form ref="form" lazy-validation>
					<v-select
						v-if="sorts.length"
						v-model="q.sorts"
						:items="sorts"
						item-text="name"
						item-value="value"
						label="並び替え"
						class="ma-1"
						no-data-text="並び替え情報がありません。"
						clearable
						dense
						outlined
					/>
					<template v-for="searchForm in searchForms">
						<v-text-field
							:key="searchForm.id"
							type="text"
							class="ma-1"
							v-if="searchForm.form_type == 'text'"
							:label="searchForm.locale_name"
							:suffix="searchForm.condition_text"
							outlined
							dense
						/>
						<v-text-field
							v-else-if="searchForm.form_type == 'number'"
							:label="searchForm.locale_name"
							:suffix="searchForm.condition_text"
							:key="searchForm.id"
							:rules="[rules.floatWithNegative]"
							class="ma-1"
							type="text"
							outlined
							dense
						/>
						<v-select
							v-else-if="searchForm.form_type == 'select'"
							v-model="q[searchParams(searchForm)]"
							:key="searchForm.id"
							:label="searchForm.locale_name"
							:suffix="searchForm.condition_text"
							:items="searchForm.ledger_search_options"
							class="ma-1"
							item-text="name"
							item-value="value"
							outlined
							dense
						/>
						<v-select
							v-else-if="searchForm.form_type == 'multi_select'"
							v-model="q[searchParams(searchForm)]"
							:label="searchForm.locale_name"
							:suffix="searchForm.condition_text"
							:items="searchForm.ledger_search_options"
							class="ma-1"
							item-text="name"
							item-value="value"
							multiple
							dense
							chips
							small-chips
							outlined
							:key="searchForm.id"
						/>
						<div v-else-if="searchForm.form_type == 'checkbox'" :key="searchForm.id">
							<h5>{{ searchFormLabel(searchForm) }}</h5>

							<v-row class="ma-1">
								<v-checkbox
									v-for="searchOption in searchForm.ledger_search_options"
									v-model="q[searchParams(searchForm)]"
									:label="searchOption.name"
									:key="searchOption.id"
									dense
									:value="searchOption.value"
									class="mr-2"
								/>
							</v-row>
						</div>
						<template v-else-if="searchForm.form_type == 'radio'">
							<template v-if="searchForm.ledger_search_options.length">
								<div :key="searchForm.id">
									<h5>{{ searchFormLabel(searchForm) }}</h5>

									<v-radio-group class="ma-1" v-model="q[searchParams(searchForm)]" dense row>
										<v-radio
											v-for="searchOption in searchForm.ledger_search_options"
											:label="searchOption.name"
											:key="searchOption.id"
											:value="searchOption.value"
										></v-radio>
									</v-radio-group>
								</div>
							</template>
							<template v-else>
								<div :key="searchForm.id">
									<h5>{{ searchFormLabel(searchForm) }}</h5>

									<v-radio-group class="ma-1" v-model="q[searchParams(searchForm)]" row>
										<v-radio :label="'◯'" value="true" />
										<v-radio :label="'×'" value="false" />
									</v-radio-group>
								</div>
							</template>
						</template>
						<v-menu
							v-else-if="searchForm.form_type == 'date'"
							:key="searchForm.id"
							close-on-content-click
							transition="scale-transition"
							offset-y
							min-width="auto"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									class="ma-1"
									v-model="q[searchParams(searchForm)]"
									:label="searchForm.locale_name"
									:suffix="searchForm.condition_text"
									required
									readonly
									outlined
									dense
									v-bind="attrs"
									v-on="on"
								></v-text-field>
							</template>
							<v-date-picker
								class="date-picker"
								v-model="q[searchParams(searchForm)]"
								no-title
								locale="ja-JP"
							>
								<v-spacer></v-spacer>
							</v-date-picker>
						</v-menu>
					</template>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="0" sm="2"></v-col>
					<v-col cols="12" sm="8">
						<v-row class="ma-0 pa-0" justify="center">
							<v-btn class="ma-1" @click="searchItems" color="primary">
								<v-icon class="mr-2">mdi-magnify</v-icon>
								検索</v-btn
							>
							<v-btn class="ma-1" @click="resetForm" outlined color="primary">
								<v-icon class="mr-2">mdi-autorenew</v-icon>
								クリア</v-btn
							>
						</v-row>
					</v-col>
					<v-col cols="0" sm="2">
						<v-row v-if="!$vuetify.breakpoint.xs" no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		query: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		sorts: { type: Array, required: false, default: () => [] },
		searchForms: { type: Array, required: false, default: () => [] },
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			// q: {},
			dialog: false,
		}
	},
	methods: {
		searchItems() {
			this.$emit("search-items", this.q)
			this.dialog = false
		},
		resetForm() {
			this.$refs.form.reset()
		},
	},
	computed: {
		searchFormLabel() {
			return (searchForm) => {
				return `${searchForm.locale_name} ${searchForm.condition_text}`
			}
		},
		searchParams() {
			return (searchForm) => {
				if (searchForm.base_model) {
					return `${searchForm.base_model}_${searchForm.column_name}${searchForm.condition}`
				} else {
					return `${searchForm.column_name}${searchForm.condition}`
				}
			}
		},
		q: {
			get() {
				return this.query
			},
			set(newValue) {
				return this.$emit("update:q", newValue)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
	margin-top: 0;
}
</style>